import { render, staticRenderFns } from "./UserNewPassword.vue?vue&type=template&id=1fe15d2d&scoped=true&"
import script from "./UserNewPassword.vue?vue&type=script&lang=js&"
export * from "./UserNewPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserNewPassword.vue?vue&type=style&index=0&id=1fe15d2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe15d2d",
  null
  
)

export default component.exports